import { Directive, ElementRef, HostListener, inject, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[pcgNoHash]',
    standalone: false
})
export class NoHashDirective {

    elRef = inject(ElementRef);
    @Optional() control = inject(NgControl);

    charArray = [];
	selectedText!: string;

	@HostListener('change')
	changeEvent() { if (this.control?.control) { this.control.control.setValue(this.elRef.nativeElement.value); } }

	@HostListener('keydown', ['$event'])
	keyEvent(event: KeyboardEvent) { 
		if ( event.key === "#") { return false; }
		if (this.control?.control) { this.control.control.setValue(this.elRef.nativeElement.value); }
	}

	@HostListener('mouseup', ['$event'])
	highlight(event: KeyboardEvent) { this.selectedText = globalThis.getSelection()?.toString() || ''; }
}
